<template>
	<div>
		<div class="conmtont">
			<div class="flex align-center justify-between padding-sm bg-white margin-tb">
				<el-breadcrumb separator-class="el-icon-minus">
				  <el-breadcrumb-item :to="{ path: '/' }"><span class="text-sm text-666">首页</span></el-breadcrumb-item>
				  <el-breadcrumb-item><span class="text-sm text-666">二手租赁</span></el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="bg-white padding-sm margin-bottom-sm">
				<div class="flex margin-bottom-sm">
					<p class="titla text-left text-xs text-666">全部分类：</p>
					<p class="flex-sub text-left">
						<span class="margin-right-sm  text-xs pointer pro-item" @click="choseprofession(item)" :class="categroyId == item.id?'text-theme':'text-666'" v-for="(item,index) in profession" :key="index">{{item.cate_name}}</span>
					</p>
				</div>
				<div class="flex margin-bottom-sm">
					<p class="titla text-left text-xs text-666">城 市：</p>
					<p class="flex-sub text-left">
						<!-- <span class="margin-right-sm  text-xs pointer pro-item" @click="chose(city,item,index)" :class="item.ischeck?'text-theme':'text-666'" v-for="(item,index) in provinceList" :key="index">{{item.name}}</span> -->
						<span class="margin-right-sm  text-xs  pointer pro-item" @click="choseprovince(item,index)" :class="provinceIndex == index?'text-theme':'text-666'" v-for="(item,index) in provinceList" :key="index">{{item.name}}</span>
					</p>
				</div>
				<div class="flex">
					<p class="titla text-left text-xs text-666">排序方式：</p>
					<p class="flex-sub text-left">
						<span class="margin-right-sm  text-xs pointer pro-item" @click="chose(sort,item,index)" :class="item.ischeck?'text-theme':'text-666'" v-for="(item,index) in sort" :key="index">{{item.name}}</span>
					</p>
				</div>
			</div>
			<div class="flex">
				<div class="flex-sub">
					<div v-if="total != 0">
						<div v-for="(item,indx) in lists" :key="indx">
							<LeaseList :data="item" :width="786" :height="184" :size="24"></LeaseList>
						</div>
						<div class="pagination">
							<el-pagination
							@current-change="handleCurrentChange"
							  background
							  layout="prev, pager, next"
							  prev-text="上一页"
							  next-text="下一页"
							  :total="total">
							</el-pagination>
						</div>
					</div>
					<div class="text-center" v-else>
						<el-empty description="暂无数据"></el-empty>
					</div>
				</div>
				<div class="margin-left" v-if="newlist.length != 0">
					<div class="flex align-center justify-between margin-bottom-sm">
						<p class="title padding-left-sm">最新租赁</p>
					</div>
					<div v-for="(item,indx) in newlist" :key="indx">
						<LeaseList :data="item" :width="387" :height="168" :size="18"></LeaseList>
					</div>
				</div>
			</div>
		</div>
		<right type="3"></right>
		<router-view />
	</div>
</template>

<script>
	import Right from '@/components/public/right.vue';
	import Top from '@/components/public/top.vue';
	import LeaseList from '@/components/list/lease-list.vue';
	import Bus from '@/store/eventBus.js'
	export default {
		components: {
			Top,
			Right,
			LeaseList
		},
		name: '',
		data() {
			return {
				page:1,
				profession:[],//全部分类
				categroyId:0,//
				city:[],//城 市
				sort:[
					{
						name:'默认排序',
						ischeck:true
					},
					{
						name:'最新排序',
						ischeck:false
					}
				],//排序方式
				lists:[],//列表
				newlist:[],//最新列表
				page:1,
				total:0,//
				
				provinceIndex:0,//
				provinceList:[],//城 市
			}
		},
		created() {
			//通知听不状态栏 选中的页面
			Bus.$emit('chosename','lease')
			this.getcity()
			this.gettype()
			this.getlist()
			this.getnewlist()
		},
		methods: {
			back(){
				this.$router.back()
			},
			//获取城市列表
			getcity(){
				this.ajax('get', '/api/work/getCityList', {}, res => {
					if(res.status == 200){
						let list = res.data;
						let obj = {
							id: 0,
							level: 2,
							pid: 0,
							name: '不限',
						}
						list.unshift(obj)
						this.provinceList = list;
						console.log(this.provinceList);
					}
				})
			},
			/**
			 * 二手租聘分类
			 * */
			gettype(){
				this.ajax('get', '/api/pc/hire/getHireCate', {}, res => {
					let arr = {
						id:0,
						cate_name:'全部岗位',
						ischeck:true
					}
					res.data.data.map(item=>{
						item.ischeck = false
					})
					res.data.data.unshift(arr)
					this.profession= res.data.data
				})
			},
			/**
			 * 获取最新租聘列表
			 **/
			getnewlist(){
				this.ajax('get', '/api/pc/hire/getlist', {
					page:1,
					limit:3
				}, res => {
					if(res.status == 200){
						
						this.newlist = res.data.data
						// this.list = res.data.data
					}
				})
			},
			handleCurrentChange: function(currentPage) {
			  this.page = currentPage;
			  this.getlist();
			},
			/**
			 * 获取租聘列表
			 **/
			getlist(){
				this.ajax('get', '/api/pc/hire/getlist', {
					page:this.page,
					cate_id:this.categroyId == 0?'':this.categroyId,
					city:this.provinceIndex == 0?'':this.provinceList[this.provinceIndex].name,
					limit:6
				}, res => {
					console.log('getlist',res);
					if(res.status == 200){
						this.lists = res.data.data
						console.log(this.lists);
						if(this.page == 1){
							this.total =  Number(res.data.lastpage) * Number(res.data.data.length)
						}
						// this.list = res.data.data
					}
				})
			},
			//分类筛选
			choseprofession(item){
				this.categroyId = item.id
				this.page = 1
				this.getlist()
			},
			//城市筛选
			choseprovince(item,index){
				this.provinceIndex = index
				this.cityname = item.name
				this.page = 1
				this.getlist()
			},
			/**
			 * 筛选
			 * list Array  要筛选的列表 
			 * item object 选中的筛选
			 * indx string  选中的下标
			 * */
			chose(list,item,indx){
				list.map((ele,iax)=>{
					ele.ischeck = false
					if(iax == indx){
						item.ischeck = true
					}
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.titla{
		width: 80px;
		word-spacing:25px;
	}
	.title{
		position: relative;
		font-size: 22px;
		&:before{
			position: absolute;
			left: 0;
			top: 50%;
			transform: translateY(-50%);
			width: 6px;
			height: 26px;
			background: #09827B;
			content: '';
			
		}
	}
	.pro-item:hover{
		color: #09827B;
	}
	/deep/ .el-pagination.is-background .btn-next,/deep/ .el-pagination.is-background .btn-prev,/deep/ .el-pagination.is-background .el-pager li{
		background: #fff !important;
	}
	/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
		background:#09827B !important;
		color: #fff !important;
	}
	/deep/ .el-pagination.is-background .btn-prev,/deep/ .el-pagination.is-background .btn-next{
		padding: 0 10px;
	}
	
	.pagination{
		margin: 59px 0;
	}
</style>



// WEBPACK FOOTER //
// src/view/index/lease.vue